import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-header-with-border',
  templateUrl: './page-header-with-border.component.html',
  styleUrls: ['./page-header-with-border.component.scss']
})
export class PageHeaderWithBorderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
